/** @jsx jsx */
import { jsx } from '@emotion/core'
import { withPrefix } from 'gatsby'
import { Location } from '@reach/router'

import {
  Button,
  GridView,
  Icon,
  Link,
  StackView,
  Text,
} from '@planning-center/ui-kit'

import DocSearch from './DocSearch'
import { AppThemePicker, DarkModeToggle } from './Theme'

import '../css/global-styles.css'
import '../css/algolia.css'

function PageHeader({ version, menuOpen, onMenuToggle, ...props }) {
  return (
    <Location>
      {({ navigate }) => (
        <GridView
          as="header"
          columnStart={1}
          columnEnd={-1}
          rowStart={1}
          rowEnd={1}
          autoFlow="column"
          columns={['auto', 5]}
          alignment="center"
          padding={2}
          spacing={2}
          mediaQueries={{
            md: {
              columns: ['auto', '1fr', 'auto'],
            },
            lg: {
              columns: [29, '1fr', 'auto'],
              columnStart: 1,
              columnEnd: -1,
              spacing: 3,
            },
          }}
          {...props}
        >
          <StackView axis="horizontal" alignment="center" spacing={0.5}>
            <StackView
              as={Link}
              to={withPrefix('/')}
              onClick={(event) => {
                event.preventDefault()
                navigate(withPrefix('/'))
              }}
              onKeyDown={(event) => {
                if (event.key === ' ' || event.key === 'Enter') {
                  event.preventDefault()
                  navigate(withPrefix('/'))
                }
              }}
              aria-label="view getting started guide"
            >
              <svg height="32" viewBox="0 0 296 96">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M132.323 59.3342C133.234 58.512 133.781 57.1417 133.781 55.1319V28H142.531V54.4011C142.531 58.6034 141.346 62.0748 138.703 64.5413C136.06 67.0079 132.323 68.1041 127.766 68.1041C123.208 68.1041 119.471 67.0992 116.828 64.6327C114.185 62.1662 113 58.6947 113 54.4925V28H121.75V55.1319C121.75 57.1417 122.297 58.512 123.208 59.3342C124.211 60.1564 125.578 60.7045 127.766 60.7045C129.953 60.7045 131.411 60.1564 132.323 59.3342ZM160.744 28H151.994V67.556H160.744V28ZM242.601 28V35.5823H254.177V67.556H262.927V35.5823H274.502V28H242.601ZM205.998 28H216.48L199.709 47.1842L218.121 67.556H206.819L193.785 52.7568V67.556H185.035V28H193.785V42.3425L205.998 28ZM233.831 28H225.081V67.556H233.831V28Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21 21V48.379C21 65.4723 34.4315 75.8571 51 75.8571C67.5685 75.8571 81 65.4723 81 48.379V21H21ZM64.0589 29.3327H47.5287L37.9412 50.6414H47.8593V67.5244L63.8936 44.2488H55.7938L64.0589 29.3327Z"
                  fill="white"
                />
              </svg>
            </StackView>
            <Link
              to="https://github.com/ministrycentered/ui-kit/releases/"
              external
              color="white"
              fontSize={4}
            >
              <Text>v{version}</Text>
            </Link>
          </StackView>
          <DocSearch />
          <Button
            theme={false}
            stroke="grey-8"
            title={`${menuOpen ? 'close' : 'open'} navigation menu`}
            icon={{
              name: menuOpen ? 'close' : 'menu',
              color: 'white',
            }}
            mediaQueries={{
              md: { visible: false },
            }}
            onClick={onMenuToggle}
          />
          <StackView
            visible={false}
            axis="horizontal"
            alignment="center"
            spacing={2}
            mediaQueries={{
              md: { visible: true },
            }}
          >
            <Link to={withPrefix('/playroom')} external color="white">
              Playroom
            </Link>
            <Link
              to="https://github.com/ministrycentered/ui-kit"
              external
              color="white"
            >
              <StackView axis="horizontal" alignment="center" spacing={1}>
                <Text>Github</Text>
                <Icon name="external" size="sm" color="grey-7" />
              </StackView>
            </Link>
            <DarkModeToggle />
            <AppThemePicker />
          </StackView>
        </GridView>
      )}
    </Location>
  )
}

export default PageHeader
